import { createFeatureSelector, createSelector } from '@ngrx/store';
import { layoutFeatureKey, LayoutState } from '../_reducers/layout.reducer';

export const selectJournalState = createFeatureSelector<LayoutState>(layoutFeatureKey);

/***
 * BOTTOM BAR
 */
export const selectBottomBarVisible = createSelector(selectJournalState, state => state.bottomBar.visible);
export const selectBottomBarInstantToggle = createSelector(selectJournalState, state => state.bottomBar.instantToggle);

/***
 * FLOATING SIDEBAR
 */
export const selectFloatingSidebarVisible = createSelector(selectJournalState, state => state.floatingSidebar.visible);

/***
 * HEADER
 */
export const selectPatientCardVisible = createSelector(selectJournalState, state => state.header.patientCardVisible);

/***
 * FOOTER
 */
export const selectFooterVisible = createSelector(selectJournalState, state => state.footer.footerVisible);

/***
 * ALL LAYOUT BARS
 */
export const selectAllLayoutBarsVisible = createSelector(
	selectBottomBarVisible, selectFloatingSidebarVisible, selectPatientCardVisible,
	(bottomBar, floatingSidebar, patientCardVisible) => {
		return { bottomBar, floatingSidebar, patientCardVisible };
	});
